import { Navigate, useLocation, useRoutes } from "react-router-dom";
import { useAuth } from "../contexts/auth";
import { useToasts } from "../contexts/toasts";
import { APP_ROUTES } from "./routes";

export default function AppRouter() {
  const { pathname } = useLocation();
  const { token, loggedUser, setLoggedUser } = useAuth();
  const { showToast } = useToasts();
  const routes = useRoutes(APP_ROUTES);

  if (["admin"].includes(pathname.split("/")[1]) && !token) {
    return <Navigate to="/login" />;
  } else if (pathname === "/login" && token) {
    return <Navigate to="/admin" />;
  }

  return routes;
}
